import React from 'react';

import { Tabs } from 'antd';

import { Container } from './styles';

import { AgedInventoryReport } from './AgedInventoryReport';
import { UnitsByTechnicians } from './DashboardTechniciansUnits';
import { InventoryStockReport } from './InventoryStockReport';
import { KPI } from './KPI';
import { Sales } from './Sales';
import { TechniciansProductivity } from './TechniciansProductivity';

export default function InventoryExport() {
  const items = [
    {
      label: 'KPI',
      key: 'kpi',
      children: <KPI />,
    },
    {
      label: 'Sales',
      key: 'sales',
      children: <Sales />,
    },
    {
      label: 'Items per User',
      key: 'itemsPerUser',
      children: <UnitsByTechnicians />,
    },
    {
      label: 'Technicians Productivity',
      key: 'techniciansProductivity',
      children: <TechniciansProductivity />,
    },
    {
      label: 'Aged Inventory Report',
      key: 'agedInventoryReport',
      children: <AgedInventoryReport />,
    },
    {
      label: 'Inventory Stock Report',
      key: 'inventoryStockReport',
      children: <InventoryStockReport />,
    },
    // {
    //   label: 'Monthly Report',
    //   key: 'monthlyReport',
    //   children: <MonthlyReport />,
    // },
  ];
  return (
    <Container>
      <Tabs items={items} defaultActiveKey="kpi" type="card" size="small" />
    </Container>
  );
}
